<div class="container">
  <label class="label">
    <span class="label-content">
      <span>{{ label() }}</span>
      <fb-scribe-suggestion-indicator
        [target]="markerTarget()"
        [fieldKey]="markerFieldKey()"
      ></fb-scribe-suggestion-indicator>
      <fb-amendment-field-indicator [rowIndex]="rowIndex()" [fieldKey]="markerFieldKey()" />
    </span>
  </label>
  <ng-select
    dropdownPosition="auto"
    appendTo="body"
    [searchable]="false"
    [placeholder]="placeholder()"
    [compareWith]="compareWith()"
    [ngModel]="value()"
    (ngModelChange)="handleSelectChange($event)"
    [ngModelOptions]="{ standalone: true }"
    class="select"
  >
    @for (option of options(); track option) {
      <ng-option [value]="option.value()">
        <ng-container [ngTemplateOutlet]="option.template" />
      </ng-option>
    }
  </ng-select>
</div>
